import React, { useEffect, useState } from "react";
import SEO from "../SEO";

export default function Courses() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const fetchPlaylistData = async () => {
      try {
        const apiKey = "AIzaSyCAfVdB0Yrd0YwQlTHYTFSQ7GPjHoim69Y";
        const channelId = "UCw5YseCcfF5JrM3yjSmSzmQ";

        const response = await fetch(
          `https://www.googleapis.com/youtube/v3/playlists?part=snippet&maxResults=8&channelId=${channelId}&key=${apiKey}`
        );

        if (!response.ok) {
          const errorData = await response.json();
          console.error("Error details:", errorData);
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setVideos(data.items);
      } catch (error) {
        console.error("Error fetching playlist data:", error.message);
      }
    };

    fetchPlaylistData();
  }, []);

  const openInYouTube = (playlistId) => {
    window.open(
      `https://www.youtube.com/playlist?list=${playlistId}`,
      "_blank"
    );
  };

  const handleOpenClick = (playlistId) => {
    // console.log(`Open button clicked for video ${playlistId}`);
    console.log("Open button clicked for video");
  };

  return (
    <>
    <SEO
      title="Learn Hacking & Programming Online – Free Courses at PPDDEH"
      description="Master hacking and programming online for free with PPDDEH. Access expert-led courses on cybersecurity, coding, and ethical hacking today!"
      url="https://www.ppddeh.com/courses"
    />
    <section className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto h-full">
        <div className="flex flex-wrap justify-center gap-10">
          {videos.map((video) => {
            const { id, snippet = {} } = video;
            const { title, thumbnails = {} } = snippet;
            const { high = {} } = thumbnails;
            const playlistId = id.playlistId || id;

            return (
              <div
                className="lg:w-1/4 md:w-1/2 p-4 w-full flex flex-col justify-between"
                key={id}
              >
                <div className="block relative h-full rounded overflow-hidden">
                  <img
                    alt="video thumbnail"
                    className="object-cover object-center w-full h-full block"
                    src={high.url}
                  />
                </div>
                <div className="mt-4">
                  <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                    CATEGORY
                  </h3>
                  <h2 className="text-gray-900 title-font text-lg font-medium">
                    {title}
                  </h2>
                </div>
                <div className="flex justify-between mt-4">
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    onClick={() => openInYouTube(playlistId)}
                  >
                    Open in YouTube
                  </button>
                  <button
                    className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                    onClick={() => handleOpenClick(playlistId)}
                  >
                    Open
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
    </>
    
  );
}
